import React from "react";
import "./LoadingCircle.scss";

export default function LoadingCircle() {
  return <div className="LoadingCircle" />;
}
